import React from "react";
import { ForgotPasswordTemplate } from "../../Templates/ForgotPasswordTemplate";

export const ForgotPassword = () => {
  return <ForgotPasswordTemplate />;
};
